import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';

import { useRefArchsForPattern } from '~/hooks/useReferenceArchitectures';

import { formatRefArchTitle } from '../utils';

interface PartOfArchitecturesProps {
  patternId: string;
}

export function PartOfArchitectures({ patternId }: PartOfArchitecturesProps): JSX.Element | null {
  const { refArchs } = useRefArchsForPattern(patternId);

  if (refArchs.length === 0) {
    return null;
  }

  return (
    <div className="mt-6 space-y-2">
      <h3 className="text-sm font-semibold text-muted uppercase tracking-wide mb-2">
        Part of Reference Architectures
      </h3>
      <div className="flex flex-wrap gap-2">
        {refArchs.map(ra => (
          <Link
            key={ra.ref_arch_id}
            to={`/patterns/architecture/${ra.ref_arch_id}`}
            className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg bg-surface-elevated hover:bg-primary/10 border border-default transition-colors"
          >
            <BuildingOfficeIcon className="h-3 w-3" />
            {formatRefArchTitle(ra.variant)}
          </Link>
        ))}
      </div>
    </div>
  );
}
